// import React from "react";

// const ProfileInfo = () => {
//   return (
//     <div className="card profile-card border-0">
//       <div className="card-body">
//         <h5 className="card-title">Profile Information</h5>

//         <div className="row">
//           <div className="col-md-6 mb-3">
//             <label>Full Name</label>
//             <input className="form-control" value="Prajwal Punatkar" />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label>Email</label>
//             <input className="form-control" value="prajwal@email.com" />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label>Mobile</label>
//             <input className="form-control" value="9325996893" />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label>E-mail</label>
//             <input className="form-control" value="prajwalpunatkar00@gmail.com" />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label>Your Gender</label>
//             <input className="form-control" value="Male" />
//           </div>
//         </div>

//         <button className="button3 mt-2">
//           Save Changes
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ProfileInfo;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = "https://ecom.cyberathon.com";

const ProfileInfo = () => {
   const userId = sessionStorage.getItem("userId");
console.log("User ID:", userId);

  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    address1: "",
  
  });
const nameRegex = /^[A-Za-z ]{3,}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[6-9]\d{9}$/;

const validateForm = () => {
  if (!formData.full_name.trim()) {
    toast.error("Full name is required");
    return false;
  }

  if (!nameRegex.test(formData.full_name)) {
    toast.error("Enter a valid full name");
    return false;
  }

  if (!formData.email.trim()) {
    toast.error("Email is required");
    return false;
  }

  if (!emailRegex.test(formData.email)) {
    toast.error("Enter a valid email address");
    return false;
  }

  if (!formData.phone.trim()) {
    toast.error("Mobile number is required");
    return false;
  }

  if (!phoneRegex.test(formData.phone)) {
    toast.error("Enter valid 10 digit mobile number");
    return false;
  }

  return true; 
};

  
  /* ================= FETCH USER DATA ================= */
  useEffect(() => {
    if (!userId) return;

    axios
      .post(`${BASE_URL}/index.php/Api/get_by_id_registration`, {
        user_id: userId,
      })
      .then((res) => {
        if (res.data.status) {
          setFormData(res.data.data);
        }
      })
      .catch(() => toast.error("Failed to load profile"));
  }, [userId]);

  /* ================= HANDLE INPUT ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  /* ================= UPDATE PROFILE ================= */
  // const handleSubmit = async () => {
  //     if (!validateForm()) return;
  //   try {
  //     const response = await axios.post(
  //       `${BASE_URL}/index.php/Api/update_registration`,
  //       {
  //         user_id: userId,
  //         full_name: formData.full_name,
  //         email: formData.email,
  //         phone: formData.phone,
  //         address1: formData.address1,
          
  //       }
  //     );

  //     if (response.data.status) {
  //       toast.success("Profile updated successfully");

  //       // ✅ Update sessionStorage immediately
  // sessionStorage.setItem("userName", formData.full_name);

  // // Optional: split first/last name too
  // const nameParts = formData.full_name.trim().split(" ");
  // sessionStorage.setItem("first_name", nameParts[0] || "");
  // sessionStorage.setItem("last_name", nameParts.slice(1).join(" ") || "");

  // // Refresh page or header component
  // window.location.reload();
  //     } else {
  //       toast.error(response.data.message || "Update failed");
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong");
  //   }
  // };
const handleSubmit = async () => {
  if (!validateForm()) return;

  try {
    const response = await axios.post(
      `${BASE_URL}/index.php/Api/update_registration`,
      {
        user_id: userId,
        full_name: formData.full_name,
        email: formData.email,
        phone: formData.phone,
        address1: formData.address1,
      }
    );

    if (response.data.status) {
      toast.success("Profile updated successfully");

      // 🔥 YAHI MAGIC HAI
      setFormData(response.data.data);

      // optional: session update
      sessionStorage.setItem("userName", response.data.data.full_name);
    } else {
      toast.error("Update failed");
    }
  } catch (err) {
    toast.error("Something went wrong");
  }
};

  return (
    <div className="card profile-card border-0">
      <div className="card-body">
        <h5 className="card-title">Profile Information</h5>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Full Name</label>
            <input className="form-control"
            name="full_name"
            value={formData.full_name}
            onChange={handleChange}/>

          </div>

          <div className="col-md-6 mb-3">
            <label>Email</label>
            <input className="form-control"
            name="email"
            value={formData.email}
            onChange={handleChange}/>
          </div>

          <div className="col-md-6 mb-3">
            <label>Mobile</label>
            <input className="form-control"  name="phone"
            value={formData.phone}
            onChange={handleChange} />
          </div>

          <div className="col-md-6 mb-3">
            <label>Address</label>
            <input className="form-control" name="address1"
            value={formData.address1}
            onChange={handleChange} />
          </div>

          
        </div>

        <button className="button3 mt-2 bg-col border-0 rounded-1 p-2 text-light" onClick={handleSubmit}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default ProfileInfo;